export const navigateDocumentRoute = (navigate, bIsDocumentsV2, cLegacyPath, cDocumentsV2Path) => {
  if (bIsDocumentsV2) {
    window.location.assign(cDocumentsV2Path);
    return;
  }

  navigate(cLegacyPath);
};

export const goToReportsDashboard = () => {
  window.location.assign('/reports');
};
